import React, { useState, useEffect, useRef } from "react";
import "./LandingPage.css";
import DesJeepicon from "../../assets/desJeepicon.png"
import { countries } from "../../GeneralComponents/Countries";
import { useNavigate } from "react-router-dom";
import { BASE_URL, get } from "../../services/Calls";
import GreeceFlag from '../../assets/greeceFlag.png'


interface IProps {
  pageFrom: any;
}

const MostPopular = ({
  pageFrom
}: IProps) => {

  const navigate = useNavigate();
  // const [tripsData,setTripsData] = useState([]);
  const [mobileView, setMobileView] = useState(window.innerWidth <= 768);
  const [tripsData, setTripsData] = useState([])

  useEffect(() => {
    function updateSize() {
      if (window.innerWidth <= 768) setMobileView(true);
      else setMobileView(false);
    }
    window.addEventListener("resize", updateSize);
  }, []);

  useEffect(() => {
    // getTrips()
    getSGP()
  }, [])

  const getSGP = async () => {
    try {
      if (pageFrom == 'landing') {
        const response = await get(BASE_URL + "/self-guided-packages?personalized=false&take=999");
        if (response && response.results && response.results.length > 0) {

          const popularResults = response.results.filter((item: any) => item.most_popular === true);
          const tempTripData: any = [...popularResults].sort(() => 0.5 - Math.random()).slice(0, 4);
          setTripsData(tempTripData);
        }
      }
      else {
        const encodedString = window.location.pathname;
        let countryName1 = decodeURIComponent(encodedString.replace('/', ''));
        let countryName = decodeURIComponent(countryName1.split('-')[0]).replace('/', '');


        const response = await get(BASE_URL + "/self-guided-packages?take=999");
        if (response && response.results.length > 0) {

          const selfGuidedPacakgesNotPersonalized = response.results.filter((item: any) => item.personalized === false);
        //  console.log('selfGuidedPacakgesNotPersonalized',selfGuidedPacakgesNotPersonalized)

          const resultsByCountry = selfGuidedPacakgesNotPersonalized.filter((item: any) => item.trip && item.trip.country && item.trip.country.name  ? item.trip.country.name === countryName : false);
         // console.log('resultsByCountry',resultsByCountry)
          setTripsData(resultsByCountry);
        }
      }
    }
    catch (ex) {
      //alert(ex)
      console.log('error', ex)
    }
  };
  const getTrips = async () => {
    try {
      const encodedString = window.location.pathname;
      const decodedString = decodeURIComponent(encodedString.replace('/', ''));
      const response = await get(BASE_URL + "/trips/byCountry?country=" + decodedString);
      setTripsData(response)
      if (response && response.results && response.results.length > 0) {
        if (pageFrom == 'landing') {
          let tempTripData: any = [];
          for (let i = 0; i < response.results.length; i++) {
            if (response.results[i].most_popular == true) {
              tempTripData.push(response.results[i])
            }
          }
          setTripsData(tempTripData)
        }
        else {
          const encodedString = window.location.pathname;
          const decodedString = decodeURIComponent(encodedString.replace('/', ''));
          let tempTripData: any = []
          for (let i = 0; i < response.results.length; i++) {
            if (response.results[i].country.name == decodedString) {
              tempTripData.push(response.results[i])
            }
          }
          setTripsData(tempTripData)
        }
      }
      // }
    }
    catch (ex) {
      //alert(ex)
      console.log('error', ex)
    }
  };

  return (
    <div>
      {tripsData && tripsData.length > 0 &&
        <div className="mostPopularMainContainer" style={{ paddingTop: "1.25vw" }}>
          {pageFrom == 'landing' &&
            <div className="mostPopularHeadingdiv">
              <div>Most popular</div>
            </div>
          }

          <div className={pageFrom == 'landing' ? "mostPopularGridViewLanding" : "mostPopularGridView"}>
            {(pageFrom == 'landing' ? tripsData.slice(0, 4) : tripsData).map((sgp: any, index: any) => (
              sgp.trip &&
              <div style={{ width: '18.25vw' }} onClick={() => {
                if (pageFrom == 'landing')
                  navigate('/' + sgp.trip.country.name + '/' + sgp.name, { state: { trip: sgp.trip, sgp: sgp } });
                else
                  navigate('/' + sgp.trip.country.name + '/' + sgp.name, { state: { trip: sgp.trip, sgp: sgp } });
              }}>

                {sgp.trip && sgp.trip.country && sgp.trip.country.flagURL &&
                  <div className="mostPopularFlagDiv">
                    <img src={sgp?.trip?.country?.flagURL} />
                  </div>
                }

                <div className="mostPopularItemDiv" style={{
                  backgroundImage: sgp?.trip?.image ? `url(${sgp.trip.image})` : 'none',
                  backgroundColor: sgp?.trip?.image ? 'transparent' : '#ccc',
                }}
                >
                  <div className="mostPopularItemOverlay">

                  </div>
                </div>
                <div className="mostPopularItemFooterDiv">
                  <div>
                    <div className="mostPopularItemName">
                      {/* The Balkan Ranges */}
                      {sgp.trip?.name}
                    </div>
                    <div className="mostPopularCountryAndDaysDiv">
                      {sgp?.trip && sgp?.trip?.country && sgp?.trip?.country?.name && <>
                        <span>{/* Country */}{sgp.trip.country.name}</span>
                      </>
                      }
                      {sgp?.trip && sgp?.trip?.days && sgp?.trip?.days.length >= 0 &&
                        <>
                          <span className="mostPopularCountryDaysDivider"></span>
                          <span>{sgp.trip.days.length} days</span>
                        </>
                      }
                    </div>
                  </div>
                  <div>
                    <img className="mostPopularJeepIcon" src={DesJeepicon} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      }
    </div>
  )
}
export default MostPopular;
